/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_No_Presets_TextInputs */



/**
* | output |
* | --- |
* | "Create a subtitle export preset before running a batch export." |
*
* @param {Explorer_Info_Batch_No_Presets_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_no_presets_text = /** @type {((inputs?: Explorer_Info_Batch_No_Presets_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_No_Presets_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez un préréglage d'exportation des sous-titres avant d'exécuter une exportation par lots.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie vor dem Ausführen eines Stapelexports eine Untertitel-Exportvorgabe.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prima di avviare un'esportazione in batch, crea un preset per l'esportazione dei sottotitoli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перед запуском пакетного экспорта создайте предустановленные параметры экспорта субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cree un ajuste predefinido para la exportación de subtítulos antes de ejecutar una exportación por lotes.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在运行批量导出之前，创建字幕导出预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチエクスポートを実行する前に、字幕エクスポートプリセットを作成してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच एक्सपोर्ट चलाने से पहले सबटाइटल एक्सपोर्ट प्रीसेट बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Crie uma predefinição de exportação de legendas antes de executar uma exportação em lote.")
	return /** @type {LocalizedString} */ ("Create a subtitle export preset before running a batch export.")
});